import { createReducer, on } from '@ngrx/store';
import * as BillingProfileActions from './billingProfile.actions';

export interface BillingProfileState {
  loading: boolean;
  error: any;
  data: any;
  deleteSuccess: boolean;
  deleteError: any;
}

export const initialState: BillingProfileState = {
  loading: false,
  error: null,
  data: null,
  deleteSuccess: false,
  deleteError: null
};

export const billingProfileReducer = createReducer(
  initialState,
  on(BillingProfileActions.fetchBillingProfile, state => ({
    ...state, loading: true
  })),
  on(BillingProfileActions.fetchBillingProfileSuccess, (state, { data }) => ({
    ...state, loading: false, data, error: null
  })),
  on(BillingProfileActions.fetchBillingProfileFailure, (state, { error }) => ({
    ...state, loading: false, error
  })),
  on(BillingProfileActions.submitBillingProfile, (state) => ({
    ...state, loading: true
  })),
  on(BillingProfileActions.submitBillingProfileSuccess, (state, { billingProfile }) => ({
    ...state, data: billingProfile, loading: false, error: null
  })),
  on(BillingProfileActions.submitBillingProfileFailure, (state, { error }) => ({
    ...state, loading: false, error
  })),
  on(BillingProfileActions.updateBillingProfile, state => ({
    ...state, loading: true
  })),
  on(BillingProfileActions.updateBillingProfileSuccess, (state, { billingProfile }) => ({
    ...state, data: billingProfile, loading: false
  })),
  on(BillingProfileActions.updateBillingProfileFailure, (state, { error }) => ({
    ...state, loading: false, error
  })),
  on(BillingProfileActions.deleteBillingProfile, state => ({
    ...state, loading: true, deleteSuccess: false, deleteError: null
  })),
  on(BillingProfileActions.deleteBillingProfileSuccess, (state, { id }) => {
    return {
      ...state,
      loading: false,
      deleteSuccess: true,
      data: null, // Clear data on delete success
      deleteError: null
    };
  }),
  on(BillingProfileActions.deleteBillingProfileFailure, (state, { error }) => {
    return {
      ...state,
      loading: false,
      deleteSuccess: false,
      deleteError: error
    };
  }),
  // Reset delete success and error flags on fetch
  on(BillingProfileActions.fetchBillingProfile, state => ({
    ...state, deleteSuccess: false, deleteError: null
  }))
);
